<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top">
    <router-link
      class="navbar-brand"
      to="/"
    >
      <img
        class="mw-100"
        :src="logo"
        height="30px"
      />
      <!-- Car
      <span class="font-weight-bold">Listing</span> -->
    </router-link>

    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarResponsive"
      aria-controls="navbarResponsive"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      class="collapse navbar-collapse"
      id="navbarResponsive"
    >
      <ul class="navbar-nav mx-auto">
        <li class="nav-item">
          <router-link
            class="nav-link nav-icon"
            to="/"
            exact
          >
            <i class="material-icons">home</i>
            <div>Home</div>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link nav-icon"
            to="/edit"
          >
            <i class="material-icons">settings</i>
            <div>Einstellungen</div>
          </router-link>
        </li>
      </ul>
    </div>
    <button
      type="button"
      class="btn btn-outline-light"
      @click="logout"
    >Logout</button>
  </nav>
</template>


<script>
import logo from '@/assets/CL-dark.png';

export default {
  name: 'Menu',
  data: () => ({
    logo,
  }),
  methods: {
    logout () {
      this.$store.dispatch('auth/logout');
      this.$router.push("/login");
    }
  }

}
</script>